import axios from 'axios';
import { CATEGORY_GET } from './categoryActionTypes';

export const getCategories = categories => {
    return {
      type: CATEGORY_GET,
      payload: categories
    }
  }


export const categoryGetItem =  () => {
    return dispatch => {
        
        return axios.get('https://catalog.tstmetal.site/categories',{
            responseType: 'json',
        }).then((res) => {
                    // если на бэке приходит верхнего уровня массив
                    const categories = Array.isArray(res.data)
                      ? res.data
                      : res.data.category_list;
                    dispatch(getCategories(categories));
                 });
    }
}


